import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import Particle from "../Particle";
import { 
  FaEnvelope, 
  FaWhatsapp, 
  FaCalendarAlt, 
  FaMapMarkerAlt,
  FaStar,
  FaCheckCircle,
  FaRocket,
  FaGem,
  FaClock,
  FaArrowRight
} from "react-icons/fa";

function LetsConnect() {
  const [hoveredCard, setHoveredCard] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 480);

  // Check for mobile and small screen on resize
  React.useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 768);
      setIsSmallScreen(width <= 480);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const contactMethods = [
    {
      icon: <FaEnvelope />,
      title: "Email",
      value: "hassanabrar202@gmail.com",
      subtitle: "Send me an email",
      description: "Direct communication via email",
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      action: () => window.open("mailto:hassanabrar202@gmail.com", "_blank"),
      badge: "Primary",
      color: "#667eea"
    },
    {
      icon: <FaWhatsapp />,
      title: "WhatsApp Chat",
      value: "+923004582841",
      subtitle: "Let's chat instantly",
      description: "Quick chat on WhatsApp",
      gradient: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
      action: () => window.open("https://wa.me/923004582841", "_blank"),
      featured: true,
      badge: "Fast Response",
      color: "#25D366"
    },
    {
      icon: <FaCalendarAlt />,
      title: "Book a Meeting",
      value: "Schedule a call",
      subtitle: "Schedule a consultation",
      description: "Book a consultation call",
      gradient: "linear-gradient(135deg, #c770f0 0%, #38f9d7 100%)",
      action: () => window.open("https://calendly.com/hassanabrar202/30min", "_blank"),
      featured: true,
      badge: "Professional",
      color: "#c770f0"
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Location",
      value: "Remote - Global",
      subtitle: "Available worldwide",
      description: "Working remotely globally",
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      action: null,
      badge: "Global",
      color: "#f093fb"
    }
  ];

  return (
    <Container fluid className="lets-connect-section" id="lets-connect" style={{
      minHeight: "100vh",
      padding: isSmallScreen ? "30px 0" : isMobile ? "40px 0" : "60px 0",
      position: "relative",
      overflow: "hidden"
    }}>
      <Particle />
      
      {/* Background Effects */}
      <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "radial-gradient(circle at 20% 80%, rgba(199, 112, 240, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(56, 249, 215, 0.1) 0%, transparent 50%)",
        pointerEvents: "none"
      }} />

      <Container style={{ position: "relative", zIndex: 2 }}>
        {/* Enhanced Header Section */}
        <div style={{ 
          textAlign: "center", 
          marginBottom: isSmallScreen ? "30px" : isMobile ? "40px" : "60px",
          padding: "0 15px"
        }}>
          {/* Floating Badge */}
          <div style={{ 
            display: "inline-flex", 
            alignItems: "center", 
            gap: isSmallScreen ? "6px" : isMobile ? "8px" : "12px",
            marginBottom: isSmallScreen ? "15px" : isMobile ? "20px" : "30px",
            padding: isSmallScreen ? "8px 16px" : isMobile ? "10px 20px" : "12px 25px",
            background: "linear-gradient(135deg, rgba(199, 112, 240, 0.15) 0%, rgba(56, 249, 215, 0.15) 100%)",
            borderRadius: "30px",
            border: "1px solid rgba(199, 112, 240, 0.3)",
            boxShadow: "0 8px 32px rgba(199, 112, 240, 0.2)",
            backdropFilter: "blur(10px)",
            animation: "float 3s ease-in-out infinite"
          }}>
            <FaRocket style={{ fontSize: isSmallScreen ? "0.8em" : isMobile ? "1em" : "1.2em", color: "#c770f0" }} />
            <span style={{ color: "#c770f0", fontSize: isSmallScreen ? "0.7em" : isMobile ? "0.8em" : "0.9em", fontWeight: "600" }}>Get In Touch</span>
            <FaGem style={{ fontSize: isSmallScreen ? "0.7em" : isMobile ? "0.8em" : "1em", color: "#38f9d7" }} />
          </div>
          
          {/* Main Heading */}
          <h1 style={{ 
            fontSize: isSmallScreen ? "clamp(1.8rem, 10vw, 2.5rem)" : isMobile ? "clamp(2rem, 8vw, 3rem)" : "clamp(2.5rem, 5vw, 4rem)",
            marginBottom: isSmallScreen ? "12px" : isMobile ? "15px" : "20px",
            background: "linear-gradient(135deg, #c770f0 0%, #38f9d7 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            fontWeight: "800",
            lineHeight: "1.2",
            letterSpacing: "-0.02em"
          }}>
            Let's <strong>Connect</strong>
          </h1>
          
          {/* Subtitle */}
          <p style={{ 
            fontSize: isSmallScreen ? "clamp(0.8rem, 4.5vw, 1rem)" : isMobile ? "clamp(0.9rem, 4vw, 1.1rem)" : "clamp(1rem, 2.5vw, 1.3rem)",
            color: "rgba(255, 255, 255, 0.9)",
            maxWidth: "800px",
            margin: "0 auto 30px auto",
            lineHeight: "1.6",
            fontWeight: "400"
          }}>
            Ready to transform your ideas into innovative solutions? Let's discuss how we can work together to build something extraordinary.
          </p>

          {/* Enhanced Primary CTA Buttons */}
          <div style={{
            display: "flex",
            justifyContent: "center",
            gap: isSmallScreen ? "12px" : isMobile ? "15px" : "20px",
            flexWrap: "wrap",
            padding: "0 10px"
          }}>
            <Button
              onClick={() => window.open("https://calendly.com/hassanabrar202/30min", "_blank")}
              style={{
                background: "linear-gradient(135deg, #c770f0 0%, #38f9d7 100%)",
                border: "none",
                borderRadius: "25px",
                padding: isSmallScreen ? "10px 16px" : isMobile ? "12px 20px" : "15px 25px",
                fontSize: isSmallScreen ? "clamp(0.75rem, 3.5vw, 0.9rem)" : isMobile ? "clamp(0.8rem, 3vw, 1rem)" : "clamp(0.9rem, 2vw, 1.1rem)",
                fontWeight: "600",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                boxShadow: "0 8px 25px rgba(199, 112, 240, 0.3)",
                minWidth: isSmallScreen ? "140px" : isMobile ? "160px" : "200px",
                justifyContent: "center",
                position: "relative",
                overflow: "hidden"
              }}
              onMouseEnter={(e) => {
                if (!isMobile) {
                  e.target.style.transform = "translateY(-3px) scale(1.02)";
                  e.target.style.boxShadow = "0 12px 35px rgba(199, 112, 240, 0.5)";
                }
              }}
              onMouseLeave={(e) => {
                if (!isMobile) {
                  e.target.style.transform = "translateY(0) scale(1)";
                  e.target.style.boxShadow = "0 8px 25px rgba(199, 112, 240, 0.3)";
                }
              }}
              onTouchStart={(e) => {
                if (isMobile) {
                  e.target.style.transform = "scale(0.95)";
                  e.target.style.boxShadow = "0 4px 15px rgba(199, 112, 240, 0.4)";
                }
              }}
              onTouchEnd={(e) => {
                if (isMobile) {
                  setTimeout(() => {
                    e.target.style.transform = "scale(1)";
                    e.target.style.boxShadow = "0 8px 25px rgba(199, 112, 240, 0.3)";
                  }, 150);
                }
              }}
            >
              <FaCalendarAlt style={{ fontSize: "1em" }} />
              {isSmallScreen ? "Schedule" : isMobile ? "Schedule" : "Schedule Meeting"}
            </Button>

            <Button
              onClick={() => window.open("https://wa.me/923004582841", "_blank")}
              style={{
                background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
                border: "none",
                borderRadius: "25px",
                padding: isSmallScreen ? "10px 16px" : isMobile ? "12px 20px" : "15px 25px",
                fontSize: isSmallScreen ? "clamp(0.75rem, 3.5vw, 0.9rem)" : isMobile ? "clamp(0.8rem, 3vw, 1rem)" : "clamp(0.9rem, 2vw, 1.1rem)",
                fontWeight: "600",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                boxShadow: "0 8px 25px rgba(37, 211, 102, 0.3)",
                minWidth: isSmallScreen ? "140px" : isMobile ? "160px" : "200px",
                justifyContent: "center",
                position: "relative",
                overflow: "hidden"
              }}
              onMouseEnter={(e) => {
                if (!isMobile) {
                  e.target.style.transform = "translateY(-3px) scale(1.02)";
                  e.target.style.boxShadow = "0 12px 35px rgba(37, 211, 102, 0.5)";
                }
              }}
              onMouseLeave={(e) => {
                if (!isMobile) {
                  e.target.style.transform = "translateY(0) scale(1)";
                  e.target.style.boxShadow = "0 8px 25px rgba(37, 211, 102, 0.3)";
                }
              }}
              onTouchStart={(e) => {
                if (isMobile) {
                  e.target.style.transform = "scale(0.95)";
                  e.target.style.boxShadow = "0 4px 15px rgba(37, 211, 102, 0.4)";
                }
              }}
              onTouchEnd={(e) => {
                if (isMobile) {
                  setTimeout(() => {
                    e.target.style.transform = "scale(1)";
                    e.target.style.boxShadow = "0 8px 25px rgba(37, 211, 102, 0.3)";
                  }, 150);
                }
              }}
            >
              <FaWhatsapp style={{ fontSize: "1em" }} />
              {isSmallScreen ? "WhatsApp" : isMobile ? "WhatsApp" : "WhatsApp Chat"}
            </Button>
          </div>
        </div>

        {/* Contact Methods Section */}
        <Row style={{ justifyContent: "center" }}>
          <Col lg={10} md={12} sm={12} style={{ marginBottom: "40px" }}>
            <div style={{
              background: "linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.02) 100%)",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              borderRadius: isSmallScreen ? "12px" : isMobile ? "16px" : "20px",
              padding: isSmallScreen ? "clamp(15px, 7vw, 25px)" : isMobile ? "clamp(20px, 6vw, 30px)" : "clamp(30px, 5vw, 50px)",
              transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.2)",
              backdropFilter: "blur(10px)",
              position: "relative",
              overflow: "hidden"
            }}>
              {/* Background Glow Effect */}
              <div style={{
                position: "absolute",
                top: "-50%",
                left: "-50%",
                width: "200%",
                height: "200%",
                background: "radial-gradient(circle, rgba(199, 112, 240, 0.05) 0%, transparent 70%)",
                animation: "rotate 20s linear infinite",
                pointerEvents: "none"
              }} />
              
              <h3 style={{
                color: "#c770f0",
                fontSize: isSmallScreen ? "clamp(1.3rem, 7vw, 1.8rem)" : isMobile ? "clamp(1.5rem, 6vw, 2rem)" : "clamp(1.8rem, 4vw, 2.5rem)",
                fontWeight: "700",
                marginBottom: isSmallScreen ? "15px" : isMobile ? "20px" : "25px",
                textAlign: "center",
                position: "relative",
                zIndex: 1
              }}>
                Get in Touch
              </h3>
              
              <p style={{
                color: "rgba(255, 255, 255, 0.8)",
                fontSize: isSmallScreen ? "clamp(0.75rem, 3.5vw, 0.9rem)" : isMobile ? "clamp(0.85rem, 3vw, 1rem)" : "clamp(0.95rem, 2vw, 1.1rem)",
                lineHeight: "1.6",
                marginBottom: isSmallScreen ? "20px" : isMobile ? "25px" : "35px",
                textAlign: "center",
                fontWeight: "400",
                position: "relative",
                zIndex: 1
              }}>
                I'm always interested in hearing about new opportunities, innovative projects, and potential collaborations. Whether you have a question about my work or want to explore how we can work together, feel free to reach out.
              </p>

              {/* Enhanced Contact Method Cards */}
              <div style={{ position: "relative", zIndex: 1 }}>
                {contactMethods.map((method, index) => (
                  <div
                    key={index}
                    style={{
                      background: hoveredCard === index 
                        ? "linear-gradient(135deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.04) 100%)"
                        : "linear-gradient(135deg, rgba(255, 255, 255, 0.06) 0%, rgba(255, 255, 255, 0.02) 100%)",
                      border: hoveredCard === index 
                        ? `2px solid ${method.color}40`
                        : "1px solid rgba(255, 255, 255, 0.08)",
                      borderRadius: isSmallScreen ? "8px" : isMobile ? "12px" : "16px",
                      padding: isSmallScreen ? "clamp(12px, 5vw, 20px)" : isMobile ? "clamp(15px, 4vw, 25px)" : "clamp(20px, 4vw, 30px)",
                      marginBottom: isSmallScreen ? "12px" : isMobile ? "15px" : "20px",
                      cursor: method.action ? "pointer" : "default",
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      position: "relative",
                      overflow: "hidden",
                      transform: hoveredCard === index ? (isSmallScreen ? "scale(1.01)" : isMobile ? "scale(1.02)" : "translateY(-3px) scale(1.01)") : "translateY(0) scale(1)",
                      boxShadow: hoveredCard === index 
                        ? `0 15px 40px rgba(0, 0, 0, 0.3), 0 0 20px ${method.color}20`
                        : "none"
                    }}
                    onClick={method.action}
                    onMouseEnter={() => {
                      if (method.action && !isMobile) {
                        setHoveredCard(index);
                      }
                    }}
                    onMouseLeave={() => {
                      if (!isMobile) {
                        setHoveredCard(null);
                      }
                    }}
                    onTouchStart={() => {
                      if (method.action && isMobile) {
                        setHoveredCard(index);
                      }
                    }}
                    onTouchEnd={() => {
                      if (isMobile) {
                        setTimeout(() => setHoveredCard(null), 200);
                      }
                    }}
                  >
                    {/* Badge */}
                    {method.badge && (
                      <div style={{
                        position: "absolute",
                        top: isSmallScreen ? "8px" : isMobile ? "12px" : "15px",
                        right: isSmallScreen ? "8px" : isMobile ? "12px" : "15px",
                        padding: isSmallScreen ? "2px 8px" : isMobile ? "3px 10px" : "4px 12px",
                        borderRadius: "12px",
                        fontSize: isSmallScreen ? "0.6rem" : isMobile ? "0.7rem" : "0.75rem",
                        fontWeight: "600",
                        background: method.gradient,
                        color: "white",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
                        transform: hoveredCard === index ? "scale(1.1)" : "scale(1)",
                        transition: "transform 0.3s ease"
                      }}>
                        {method.badge}
                      </div>
                    )}

                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      gap: isSmallScreen ? "clamp(8px, 4vw, 15px)" : isMobile ? "clamp(12px, 3vw, 20px)" : "clamp(15px, 3vw, 25px)",
                      flexWrap: "wrap"
                    }}>
                      <div style={{
                        background: method.gradient,
                        borderRadius: isSmallScreen ? "8px" : isMobile ? "10px" : "14px",
                        padding: isSmallScreen ? "clamp(8px, 3vw, 12px)" : isMobile ? "clamp(10px, 2.5vw, 15px)" : "clamp(12px, 2.5vw, 18px)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: isSmallScreen ? "clamp(0.8rem, 4vw, 1.2rem)" : isMobile ? "clamp(1rem, 3vw, 1.4rem)" : "clamp(1.2rem, 2.5vw, 1.6rem)",
                        color: "white",
                        minWidth: isSmallScreen ? "clamp(35px, 12vw, 45px)" : isMobile ? "clamp(40px, 10vw, 55px)" : "clamp(50px, 8vw, 65px)",
                        height: isSmallScreen ? "clamp(35px, 12vw, 45px)" : isMobile ? "clamp(40px, 10vw, 55px)" : "clamp(50px, 8vw, 65px)",
                        boxShadow: hoveredCard === index 
                          ? `0 8px 25px rgba(0, 0, 0, 0.3), 0 0 15px ${method.color}40`
                          : "0 6px 20px rgba(0, 0, 0, 0.2)",
                        flexShrink: 0,
                        transform: hoveredCard === index ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.3s ease"
                      }}>
                        {method.icon}
                      </div>
                      
                      <div style={{ flex: 1, minWidth: isSmallScreen ? "120px" : isMobile ? "150px" : "200px" }}>
                        <div style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          marginBottom: "8px",
                          flexWrap: "wrap"
                        }}>
                          <h5 style={{
                            color: "white",
                            fontSize: isSmallScreen ? "clamp(0.9rem, 4vw, 1.2rem)" : isMobile ? "clamp(1rem, 3vw, 1.3rem)" : "clamp(1.1rem, 2.5vw, 1.4rem)",
                            fontWeight: "600",
                            margin: 0
                          }}>
                            {method.title}
                          </h5>
                          {method.featured && (
                            <FaStar style={{ 
                              color: "#38f9d7", 
                              fontSize: isSmallScreen ? "0.7rem" : isMobile ? "0.8rem" : "0.9rem",
                              animation: hoveredCard === index ? "pulse 1s infinite" : "none"
                            }} />
                          )}
                        </div>
                        
                        <p style={{
                          color: method.color,
                          fontSize: isSmallScreen ? "clamp(0.7rem, 3vw, 0.9rem)" : isMobile ? "clamp(0.8rem, 2.5vw, 1rem)" : "clamp(0.9rem, 2vw, 1.1rem)",
                          fontWeight: "500",
                          margin: "0 0 6px 0"
                        }}>
                          {method.value}
                        </p>
                        
                        <p style={{
                          color: "rgba(255, 255, 255, 0.8)",
                          fontSize: isSmallScreen ? "clamp(0.65rem, 3vw, 0.8rem)" : isMobile ? "clamp(0.75rem, 2.5vw, 0.9rem)" : "clamp(0.85rem, 2vw, 1rem)",
                          margin: "0 0 4px 0",
                          fontWeight: "400"
                        }}>
                          {method.subtitle}
                        </p>
                        
                        <p style={{
                          color: "rgba(255, 255, 255, 0.6)",
                          fontSize: isSmallScreen ? "clamp(0.6rem, 2.5vw, 0.7rem)" : isMobile ? "clamp(0.7rem, 2vw, 0.8rem)" : "clamp(0.8rem, 1.8vw, 0.9rem)",
                          margin: 0,
                          fontStyle: "italic"
                        }}>
                          {method.description}
                        </p>
                      </div>
                      
                      {method.action && (
                        <FaArrowRight style={{
                          color: method.color,
                          fontSize: isSmallScreen ? "clamp(0.8rem, 4vw, 1.1rem)" : isMobile ? "clamp(1rem, 3vw, 1.3rem)" : "clamp(1.1rem, 2.5vw, 1.4rem)",
                          marginLeft: "auto",
                          transition: "all 0.3s ease",
                          transform: hoveredCard === index ? "translateX(5px)" : "translateX(0)"
                        }} />
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Enhanced Currently Available Status */}
              <div style={{
                background: "linear-gradient(135deg, rgba(56, 249, 215, 0.1) 0%, rgba(56, 249, 215, 0.05) 100%)",
                border: "1px solid rgba(56, 249, 215, 0.3)",
                borderRadius: isSmallScreen ? "8px" : isMobile ? "12px" : "16px",
                padding: isSmallScreen ? "clamp(12px, 5vw, 20px)" : isMobile ? "clamp(15px, 4vw, 25px)" : "clamp(20px, 4vw, 30px)",
                marginTop: isSmallScreen ? "20px" : isMobile ? "25px" : "30px",
                textAlign: "center",
                position: "relative",
                zIndex: 1
              }}>
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: isSmallScreen ? "8px" : isMobile ? "10px" : "12px",
                  marginBottom: isSmallScreen ? "8px" : isMobile ? "10px" : "12px",
                  flexWrap: "wrap"
                }}>
                  <FaCheckCircle style={{ 
                    color: "#38f9d7", 
                    fontSize: isSmallScreen ? "clamp(0.8rem, 4vw, 1.2rem)" : isMobile ? "clamp(1rem, 3vw, 1.4rem)" : "clamp(1.2rem, 2.5vw, 1.6rem)",
                    animation: "pulse 2s infinite"
                  }} />
                  <span style={{
                    color: "#38f9d7",
                    fontSize: isSmallScreen ? "clamp(0.8rem, 4vw, 1.2rem)" : isMobile ? "clamp(1rem, 3vw, 1.3rem)" : "clamp(1.1rem, 2.5vw, 1.4rem)",
                    fontWeight: "600"
                  }}>
                    Currently Available
                  </span>
                </div>
                <p style={{
                  color: "rgba(255, 255, 255, 0.9)",
                  fontSize: isSmallScreen ? "clamp(0.7rem, 3vw, 0.9rem)" : isMobile ? "clamp(0.8rem, 2.5vw, 1rem)" : "clamp(0.9rem, 2vw, 1.1rem)",
                  margin: "0 0 8px 0",
                  fontWeight: "400"
                }}>
                  Open to new opportunities and exciting projects.
                </p>
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  fontSize: isSmallScreen ? "clamp(0.65rem, 3vw, 0.8rem)" : isMobile ? "clamp(0.75rem, 2.5vw, 0.9rem)" : "clamp(0.85rem, 2vw, 1rem)",
                  color: "rgba(255, 255, 255, 0.7)",
                  flexWrap: "wrap"
                }}>
                  <FaClock style={{ fontSize: isSmallScreen ? "0.6rem" : isMobile ? "0.7rem" : "0.8rem" }} />
                  Typical response time: 24-48 hours
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        
        @keyframes rotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.8; transform: scale(1.05); }
        }

        @media (max-width: 768px) {
          .lets-connect-section {
            padding: 40px 0 !important;
          }
        }

        @media (max-width: 480px) {
          .lets-connect-section {
            padding: 30px 0 !important;
          }
        }

        /* Touch device optimizations */
        @media (hover: none) and (pointer: coarse) {
          .lets-connect-section button:hover {
            transform: none !important;
          }
        }

        /* Extra small screens */
        @media (max-width: 360px) {
          .lets-connect-section {
            padding: 20px 0 !important;
          }
        }
      `}</style>
    </Container>
  );
}

export default LetsConnect;
